module.exports = __webpack_public_path__ + "img/bible.e9b76cc5.png";